// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class FlowAuthController {
   $scope: any
   $timeout: any
   flow: any
   constructor($scope: any, $timeout: any, flow: any) {
      this.signOff = this.signOff.bind(this)
      this.toggleBanner = this.toggleBanner.bind(this)
      this.getCallbackUrl = this.getCallbackUrl.bind(this)
      this.getCurrentUrl = this.getCurrentUrl.bind(this)
      this.sendAuthParams = this.sendAuthParams.bind(this)
      this.$scope = $scope
      this.$timeout = $timeout
      this.flow = flow
      this.$scope.flowConfigs     = this.flow.configs
      this.$scope.auth            = this.flow.auth
      this.$scope.signOff         = this.signOff
      this.$scope.toggleBanner    = this.toggleBanner
      this.$scope.getCallbackUrl  = this.getCallbackUrl
      this.$scope.getCurrentUrl   = this.getCurrentUrl
      this.$scope.sendAuthParams   = this.sendAuthParams
   }

   signOff() {
      // need to add timeout to allow IE to process form submission - SUM-90264
      return this.$timeout((() => this.flow.signOff()), 5)
   }

   toggleBanner(val: any) {
      return this.flow.configs.banner.enabled = val
   }

   getCallbackUrl() {
      return this.flow.getCallbackUrl()
   }

   getCurrentUrl() {
      return this.flow.getCurrentUrl()
   }

   sendAuthParams() {
      return this.flow.getAuthParams().then(([timeStamp, signature]: [number, any]) => {
         return { ts: timeStamp, sig: signature }
      }).catch((error: any) => {
         console.error('Error getting auth params:', error)
      })
   }
}

FlowAuthController.$inject = ['$scope', '$timeout', 'flowService']

angular.module('summonApp.controllers')
   .controller('FlowAuthCtrl', FlowAuthController)
